import { PageViewEvent } from '@shopify/events';
import { onDocumentReady } from '@theme/utilities';

const dispatchWhenReady = () =>
  onDocumentReady(
    function dispatchPageViewEvent() {
      const templateElement = document.querySelector('main[data-template]');
      const template = templateElement?.dataset.template || '';

      document.dispatchEvent(
        new PageViewEvent({
          page: {
            template,
            title: document.title,
            url: window.location.href,
          },
        })
      );
    },
    { once: true }
  );

if (  (document).prerendering) {
  document.addEventListener('prerenderingchange', dispatchWhenReady, { once: true });
} else {
  dispatchWhenReady();
}
